// Bound for analytics `getSegmentUser()` lookups. A slow/blocked Segment SDK
// must never hold — or fail — a charge, its post-charge transition, or a gift
// redemption: callers wrap the lookup in withTimeout() and degrade to no ids
// (OMG-2147). Shared so the checkout onSubmit, the post-charge handleSuccess,
// and the gift-redeem flow all use one value.
export const SEGMENT_USER_TIMEOUT_MS = 3_000;
